import { useWorkPageStore, WorkStatus } from '@diana/core';

export const WorkPageStatus = () => {
  const work = useWorkPageStore((store) => store.work);

  return work ? (
    <WorkStatus work={work} sxBox={{ mb: 0, ml: 1, px: 1, py: 0, minHeight: 'auto' }} />
  ) : null;
};
